var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38318",
    "data-name": "Group 38318",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.538,
    height: 12.565,
    viewBox: "0 0 10.538 12.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27840",
    "data-name": "Path 27840",
    d: "M367.267,53.245l1.83,1.835-.007.007h-1.807l-.017-1.842Z",
    transform: "translate(-358.566 -53.243)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27841",
    "data-name": "Path 27841",
    d: "M189.74,132.291a.452.452,0,0,1-.493.51.613.613,0,0,1-.114-.006v-.954a.686.686,0,0,1,.149-.013A.418.418,0,0,1,189.74,132.291Z",
    transform: "translate(-185.95 -129.392)",
    fill: "#f1f1f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27842",
    "data-name": "Path 27842",
    d: "M148.822,131.912c0,.149-.108.238-.283.238a.509.509,0,0,1-.11-.009v-.43a.569.569,0,0,1,.136-.013C148.729,131.7,148.822,131.778,148.822,131.912Z",
    transform: "translate(-146.506 -129.266)",
    fill: "#f1f1f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27843",
    "data-name": "Path 27843",
    d: "M87.612,94.625h5.674V97.9H86.4V94.625h1.216Z",
    transform: "translate(-86.396 -93.342)",
    fill: "#f1f1f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27844",
    "data-name": "Path 27844",
    d: "M267.465,242.888a4.439,4.439,0,0,1-.214,1,1.827,1.827,0,0,1-.225-.893c0-.391.126-.5.225-.5S267.461,242.548,267.465,242.888Z",
    transform: "translate(-261.432 -236.637)",
    fill: "#dc1d00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27845",
    "data-name": "Path 27845",
    d: "M316.515,342.191c0,.449-.814.266-1.315-.21C315.2,341.981,316.515,341.742,316.515,342.191Z",
    transform: "translate(-308.112 -332.974)",
    fill: "#dc1d00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27846",
    "data-name": "Path 27846",
    d: "M202.662,366.995c-.4-.241.846-.984,1.071-1.008C203.733,365.987,203.084,367.247,202.662,366.995Z",
    transform: "translate(-198.984 -356.298)",
    fill: "#dc1d00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27847",
    "data-name": "Path 27847",
    d: "M264.717,311.26a5.858,5.858,0,0,0,.684.929,5.333,5.333,0,0,0-.578.119,3.119,3.119,0,0,0-.607.2l.166-.371C264.547,311.766,264.717,311.26,264.717,311.26Z",
    transform: "translate(-258.707 -303.266)",
    fill: "#dc1d00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27848",
    "data-name": "Path 27848",
    d: "M134.972,55.035V65.756H125.65v-8h5.674V54.474H125.65V53.191h7.484v0h0l.017,1.842h1.807l.007-.007Z",
    transform: "translate(-124.434 -53.191)",
    fill: "#fc644d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27849",
    "data-name": "Path 27849",
    d: "M198.489,241.623c-.225.024-1.474.766-1.071,1.008C197.84,242.883,198.489,241.623,198.489,241.623Zm2.338-.682c.5.477,1.315.66,1.315.21S200.827,240.941,200.827,240.941Zm-.394-.084a5.853,5.853,0,0,1-.684-.929s-.17.506-.336.877l-.166.372a3.119,3.119,0,0,1,.607-.2A5.333,5.333,0,0,1,200.433,240.856Zm-.873-1.668a4.441,4.441,0,0,0,.213-1c0-.34-.115-.387-.213-.387s-.225.107-.225.5A1.827,1.827,0,0,0,199.56,239.189Zm.273.514a5.164,5.164,0,0,0,.83,1.094,5.856,5.856,0,0,1,1.011-.071c.814-.02.85.438.853.478s.036.4-.612.427a2.215,2.215,0,0,1-1.32-.652s-.276.044-.505.1-.964.257-.964.257a9.311,9.311,0,0,1-.7,1.027c-.482.632-1.022.585-1.176.376-.179-.243-.041-.486.3-.8a3.967,3.967,0,0,1,1.124-.578s.158-.284.39-.827.407-1.088.407-1.088a3.836,3.836,0,0,1-.274-.964c-.05-.494.005-.826.385-.83s.5.281.51.774A4.852,4.852,0,0,1,199.832,239.7Z",
    transform: "translate(-193.739 -231.934)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38317",
    "data-name": "Group 38317",
    transform: "translate(1.568 2.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27850",
    "data-name": "Path 27850",
    d: "M227.867,124.279V124H227v1.456h.31v-.589h.527v-.248h-.527v-.341Z",
    transform: "translate(-224.212 -123.989)",
    fill: "#fc644d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27851",
    "data-name": "Path 27851",
    d: "M179.056,123.817a.958.958,0,0,0-.6-.156,3.051,3.051,0,0,0-.452.03v1.431a3.126,3.126,0,0,0,.381.022,1.056,1.056,0,0,0,.676-.188.74.74,0,0,0,.244-.59A.643.643,0,0,0,179.056,123.817Zm-.614,1.07a1.068,1.068,0,0,1-.132-.006v-.954a1.275,1.275,0,0,1,.167-.013.418.418,0,0,1,.458.463A.452.452,0,0,1,178.442,124.887Z",
    transform: "translate(-176.73 -123.661)",
    fill: "#fc644d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27852",
    "data-name": "Path 27852",
    d: "M137.918,123.779a.742.742,0,0,0-.459-.117,2.819,2.819,0,0,0-.459.03v1.436h.341v-.519a.929.929,0,0,0,.119.007.684.684,0,0,0,.477-.154.467.467,0,0,0,.136-.346A.425.425,0,0,0,137.918,123.779Zm-.461.584a.6.6,0,0,1-.117-.009v-.43a.691.691,0,0,1,.143-.013c.165,0,.257.08.257.214C137.741,124.274,137.633,124.363,137.458,124.363Z",
    transform: "translate(-137 -123.662)",
    fill: "#fc644d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.884face243fbbb54e86602f8052905bd.svg";
export { ForwardRef as ReactComponent };